/*
 * @Description: 精准营销 - 人群营销 页面
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Balloon, Button, DatePicker, Dialog, Form, Icon, Input, Loading, Message, Select, Table } from '@alifd/next';
import style from './index.module.scss';
import LzPagination from '@/components/common/LzPagination';
import LzTag from '@/components/common/LzTag';
import { appHistory } from '@ice/stark-app';
import moment from 'moment';
import utils from '@/common/utils';
import { store } from '@ice/stark-data';
import { Servlets } from '@/service';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { Tooltip } = Balloon;
/** 人群营销页面 getMarketingtasksList */
const MarketingList = (): JSX.Element => {
  const [isLoading, setLoading] = useState(false);// 是否正在加载页面数据
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [searchFormData, setSearchFormData] = useState({});// 搜索表单数据集合
  const [dataSource, setDataSource] = useState([]);// 列表数据
  const [columns, setColumns] = useState([{}]);// 列表title
  const [sendStatusDisc, setSendStatusDisc] = useState([{ label: '', value: '' }]);// 状态类型sendStatus 字典项
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据

  /** 生命周期函数 */
  useEffect(() => {
    init();
    utils.setBreadcrumb({
      name: '精准营销', // 一级页面名称
      url: '/web/crowdMarketing', // 一级页面url
      children: {
        name: '官方人群营销', // 一级页面名称
        url: '/web/crowdMarketing', // 一级页面url
      },
    });
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    /** 状态类型数据字典 */
    const getSendStatusDisc = [
      { label: '全部状态', value: '' },
      { label: '未执行', value: '0' },
      { label: '执行中', value: '1' },
      { label: '执行成功', value: '2' },
      { label: '执行失败', value: '3' },
      { label: '手动停止', value: '4' },
    ];

    setSendStatusDisc(getSendStatusDisc);
    getListData();
  };

  /** 获取列表数据 */ // type: 1-人群营销 2-订单筛选营销
  const getListData = (searchForm = { pageNo: 1, pageSize: 10, pageNum: 1, type: 1 }): void => {
    setLoading(true);

    // 获取订单筛选列表数据
    Servlets('getMarketingtasksList', { ...searchForm, ...{ pageNum: searchForm.pageNo ? searchForm.pageNo : searchForm.pageNum } }, false)
      .then((res: { data: []; page: { pageNo: number; pageSize: number; total: number } }) => {
        setLoading(false);// 关闭loading

        setDataSource(res.data ? res.data : []); // 获取列表数据

        setPageInfo(res.page ? res.page : pageInfo);// 设置分页
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  /** 搜索表单提交时触发 */
  const handleSubmit = (val: any): void => {
    let timeRange = {
      createStartTime: val.createTime && val.createTime.length!==0 && val.createTime[0] ? moment(val.createTime[0]).format('x') : '', // 创建起始时间 起始
      createEndTime: val.createTime && val.createTime.length!==0 && val.createTime[1] ? moment(val.createTime[1]).format('x') : '', // 创建截止时间 结束
      pushStartTime: val.excuteTime && val.excuteTime.length!==0 && val.excuteTime[0]  ? moment(val.excuteTime[0]).format('x') : '', // 推送起始时间 起始
      pushEndTime: val.excuteTime && val.excuteTime.length!==0 && val.excuteTime[1] ? moment(val.excuteTime[1]).format('x') : '', // 推送截止时间 结束
    }
    setSearchFormData({
      name: val.name, // 营销主题
      status: val.sendStatus, // 活动状态
      type: 1, // 活动类型 1:人群营销 2：订单筛选营销
      ...timeRange
    });

    const searchForm = {
      ...{
        name: val.name, // 营销主题
        status: val.sendStatus, // 活动状态
        type: 1, // 活动类型 1:人群营销 2：订单筛选营销
      },
      ...timeRange,
      ...{ // 分页
        pageNo: 1,
        pageNum: 1,
        pageSize: pageInfo.pageSize,
      },
    };
    getListData(searchForm);
  };
  /** 搜索表单重置时触发 */
  const handleReset = (): void => {
    setSearchFormData({});
    getListData();
  };

  /** 展示短信内容 */
  const showShorMessageDialog = (record: {} = {}): void => {
    const smsTotalNum = record.smsSign.length + record.smsContent.length + record.shortUrl.length+2
    const dialog = Dialog.show({
      title: '短信内容',
      className: 'quickDialog_hjy',
      content:
  <div className="container">
    <p className="title">短信内容：</p>
    <p className="content">【{record.smsSign}】{record.smsContent}{record.shortUrl}</p>
    <p className="info">字数/计费（条）：<span>{smsTotalNum}/{smsTotalNum<=70 ? Math.ceil(smsTotalNum/70) :  Math.ceil(smsTotalNum/67)} </span></p>
  </div>,
      footer: (
        <Button className="close" warning type="secondary" onClick={() => dialog.hide()}>
          关闭
        </Button>
      ),
    });
  };

  /**
   * @description: 取消推送
   * @param {*} record-列表本条数据内容
   * @return {*}
   */
  const cancel_push = (record = {}) => {
    Message.loading('取消推送中，请稍等...');

    Servlets('deleteMarketingtask', { Id: record.id }).then((res: { success: boolean; data: object }) => {
      if (!res.success || !res.data) return;

      getListData();
      setTimeout(() => {
        Message.success({ title: '已取消推送', duration: 1500 });
      }, 500);
    });
  };

  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages: object = {}): Promise<void> => {
    setLoadingForList(true);
    setTimeout(() => {
      setLoadingForList(false);
    }, 500);
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      getListData({ pageNo: pages.pageNo, pageNum: 1, pageSize: pages.pageSize, type: 1, ...searchFormData });
    } catch (e) {
      // LzMsg.error(e.message);
    }
  };

  /** (打开 新建订单筛选营销任务 弹窗) 或(由子组件调用，告知父组件，子组件弹窗是否已关闭) */
  const openDialog_CreateShortMesssage = (visible = true): void => {
    store.set('fromUrlToCreateMarket', '/Crowdmarket');
    const Params = {
      marketingType: '1', // "营销类型 1-人群营销 2-订单筛选营销",
      marketingTypeText: '人群营销', // "营销类型 1-人群营销 2-订单筛选营销",
      orderCrowdType: 0, // 订单营销下的筛选类型
    };

    // 将参数传递至仓库与缓存，若用户刷新页面时仓库数据被清空则使用缓存数据
    store.set('sceneMarketingParams', Params);
    localStorage.setItem('sceneMarketingParams', JSON.stringify(Params));

    // 路由跳转--  打开【新建订单筛选营销任务】页面
    appHistory.push('./crowdMarketing/create');
  };

  /** 打开营销效果弹窗 */
  const openDialog_MarketingEffect = (visible = true, record: object = {}): void => {
    // 将参数传递至仓库与缓存，若用户刷新页面时仓库数据被清空则使用缓存数据
    store.set('crowdPeople_hjy', record);
    localStorage.setItem('crowdPeople_hjy', JSON.stringify(record));
    localStorage.setItem('tab', 'tabCrowdMarketing');
    // 路由跳转 -- 打开营销效果页面 ，
    appHistory.push(`./crowdMarketing/marketingEffect/task/${record.id}`);
  };

  return (
    <>
      <Loading visible={isLoading} fullScreen>
        {
          <div className={style.mainBox}>
            <div>
              <div />
              <div className={style.pageInfoNotice}>
                <div>
                  <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                  <div>
                    <p>1.短信发送时间范围为：9:00-20:00（日常）、早8:00-凌晨2点（大促）</p>
                    <p>2.通过官方标签筛选后的人群，可用官方人群营销进行批量投放营销</p>
                  </div>
                </div>
              </div>

              <div className={style.formAndListStyle}>
                {/* 搜索表单 */}
                <div className={style.listSearch}>
                  <Form
                    inline
                    className={`${style.listSearchForm} form-crowdMarketing`}
                    size="medium"
                    value={searchFormData}
                  >
                    <FormItem label="营销主题:" className={style.formItem}>
                      <Input
                        name="name"
                        className={style.formItem_width}
                        placeholder="请输入..."
                        maxLength={100}
                        hasClear
                      />
                    </FormItem>

                    <FormItem label="创建时间:" className={style.formItem}>
                      <RangePicker
                        popupAlign="tr tr"
                        name="createTime"
                        placeholder="请点选..."
                        className={style.formItem_width}
                        followTrigger
                        disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                        showTime
                      />
                    </FormItem>

                    <FormItem label="活动状态:" className={style.formItem}>
                      <Select
                        placeholder="请点选..."
                        name="sendStatus"
                        className={style.formItem_width}
                        hasClear
                        dataSource={sendStatusDisc}
                        followTrigger
                      />
                    </FormItem>

                    <FormItem label="推送时间:" className={style.formItem}>
                      <RangePicker
                        popupAlign="tl tl"
                        name="excuteTime"
                        placeholder="请点选..."
                        className={style.formItem_width}
                        followTrigger
                        showTime
                      />
                    </FormItem>

                    <FormItem
                      label=""
                      className={`${style.formItem} form-crowdMarketing-btn`}
                      style={{ textAlign: 'right' }}
                    >
                      <Form.Submit
                        className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                        type="primary"
                        onClick={handleSubmit}
                      >查询
                      </Form.Submit>
                      <Form.Reset
                        className={`${style.submitBtnStyle_width}`}
                        onClick={handleReset}
                      >重置
                      </Form.Reset>
                    </FormItem>
                  </Form>
                </div>

                {/* 列表 */}
                <div className={style.listContent}>

                  <div className={style.TopButton}><Button
                    type="primary"
                    style={{ marginRight: 6 }}
                    onClick={() => openDialog_CreateShortMesssage()}
                  >+&nbsp;新建官方人群营销
                  </Button>
                  </div>
                  <div style={{ marginTop: 8 }}>
                    <Table.StickyLock
                      dataSource={dataSource}
                      loading={isLoadingForList}
                    >
                      <Table.Column
                        title="推送时间"
                        align="left"
                        width="180px"
                        cell={(value, index, record) => (
                          <span>{moment(record.excuteTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                        )}
                      />
                      <Table.Column
                        title="创建时间"
                        width="180px"
                        align="left"
                        cell={(value, index, record) => (
                          <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                        )}
                      />
                      <Table.Column title="营销主题" width="180px" align="left" dataIndex="name" />
                      <Table.Column
                        title="推送人群"
                        width="180px"
                        align="left"
                        dataIndex="packageName"
                      />
                      <Table.Column
                        title="推送人群数量"
                        width="150px"
                        align="left"
                        cell={(value, index, record) => (
                          <span>{record.expectPeopleNum.toLocaleString()}</span>
                        )}
                      />
                      <Table.Column
                        width="150px"
                        title={
                        <div>
                        <span>推送成功人数</span>
                        <Tooltip
                          id="aria-tooltip"
                          align="t"
                          trigger={
                            <span className={`${style['icon-style']} iconfont icon-icon4-33`}></span>
                          }
                        >
                          发送成功后获取
                        </Tooltip>
                        </div>}
                        dataIndex="reachPeopleNum"
                        cell={(value, index, record) => (
                          <span>{value === -1 ? 0 : value}</span>
                        )}
                      />
                      <Table.Column
                        width="100px"
                        title="状态"
                        align="left"
                        cell={(value, index, record) => {
                          // 活动状态 0-未执行 1-执行中 2-执行成功 3-执行失败 4-手动停止
                          const arr = [LzTag.Disable, LzTag.Success, LzTag.Success, LzTag.Error, LzTag.Error];
                          const wd = ['未执行', '执行中', '执行成功', '执行失败', '手动停止'];
                          const Content = arr[record.status];
                          return (<div style={{ userSelect: 'none' }}>
                            <Content>{wd[record.status]}</Content>
                            {
                              record.status === 3 &&
                              <Tooltip
                              align="t"
                              trigger={
                                <span className={`${style['icon-style']} iconfont icon-icon4-33`}></span>
                              }
                            >
                              {record.remark}
                            </Tooltip>
                            }
                            {/* <div>{wd[record.status]}</div> */}
                          </div>);
                        }}
                      />
                      <Table.Column
                        width="240px"
                        title="操作"
                        align="left"
                        lock="right"
                        cell={(value, index, record) => (
                          <div>
                            {
                              record.status === 2 ? <Button
                                type="primary"
                                text
                                onClick={() => openDialog_MarketingEffect(true, record)}
                              >营销效果
                              </Button> :
                              <span style={{
                                color: '#C3CBD6',
                                cursor: 'no-drop',
                              }}
                              >营销效果
                              </span>
                            }

                            <Button
                              type="primary"
                              text
                              onClick={() => showShorMessageDialog(record)}
                              style={{ marginLeft: '10px' }}
                            >短信内容
                            </Button>

                            {
                                          (record.excuteType === 1 && record.status === 0) ?
                                            <Button
                                              type="primary"
                                              className={style.ml10}
                                              text
                                              onClick={() => cancel_push(record)}
                                            >取消推送
                                            </Button>
                                            : <span style={{
                                              color: '#C3CBD6',
                                              cursor: 'no-drop',
                                              marginLeft: '10px',
                                            }}
                                            >取消推送
                                            </span>
                                        }
                          </div>
                        )}
                      />
                    </Table.StickyLock>
                  </div>

                  {
                    !!dataSource.length && <div
                        attr-intro="分页组件"
                        className={[style.Pagination, 'Hjy-Pagination'].join(' ')}
                    >
                      <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
                    </div>
                  }
                </div>
              </div>

            </div>

          </div>

        }
      </Loading>

    </>
  );
};

export default MarketingList;
